module.exports = __webpack_public_path__ + "static/img/pricing-table-background.1cfe0485.jpg";